/** @jsxImportSource @emotion/react */
"use client";
import type { IconButtonProps, WithButtonWrapper } from "@packages/ui";
import { IconButton, ScreenSizeIcon } from "@packages/ui";
import { HallowDataTestId } from "@tools/playwright/global";

import { useMediaClass } from "../../../utils/media.emotion";
import { FragmentAsChild } from "../../primitives/FragmentAsChild";

export type GoFullscreenProps = WithButtonWrapper<
  Partial<IconButtonProps> & {
    onFullscreen: any;
    onExitFullscreen: any;
    variant?: "transparentWhite" | "lighten";
  }
>;

export const GoFullscreen = ({
  Wrapper = FragmentAsChild,
  onFullscreen,
  onExitFullscreen,
  variant = "transparentWhite",
  ...props
}: GoFullscreenProps) => {
  const mediaClass = useMediaClass();
  return (
    <Wrapper asChild>
      <IconButton
        variant={variant}
        data-testid={HallowDataTestId.MediaFullscreen}
        icon={
          mediaClass.includes("fullscreen") ? (
            <ScreenSizeIcon.Minimize />
          ) : (
            <ScreenSizeIcon.Maximize />
          )
        }
        {...props}
        onClick={
          mediaClass.includes("fullscreen") ? onExitFullscreen : onFullscreen
        }
      />
    </Wrapper>
  );
};
